
import { defineComponent, PropType } from "vue";
import ItemListFilter from "modules/spravochnik/dt-front-page-generator/components/Filter/index.vue";
import Popper from "vue3-popper";
import { formatTextByNumber } from "@app/vue/Utils/src/string";

enum SortType {
    DATE_PUBLISH_DESC = 'date_publish_desc',
    DATE_PUBLISH_ASC = 'date_publish_asc',
    DATE_START_DESC = 'date_start_desc',
    DATE_START_ASC = 'date_start_asc',
    DATE_END_DESC = 'date_end_desc',
    DATE_END_ASC = 'date_end_asc',
}

interface SortOption {
    key: SortType;
    label: string;
    field: string;
    order: 'asc' | 'desc';
}

export default defineComponent({
    name: 'Filter',
    components: {
        ItemListFilter,
        Popper,
    },
    props: {
        count: {
            type: Number,
            required: true,
        },
        isShowCW: {
            type: Boolean,
            default: true,
        },
        filters: {
            type: Object as PropType<any>,
            default: () => ({}),
        },
        isArchive: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            dateUser: null as string | null,
            selectedSort: SortType.DATE_PUBLISH_DESC,
            sortOptions: [
                {
                    key: SortType.DATE_PUBLISH_DESC,
                    label: 'Дата публикации (убыв.)',
                    field: 'datePublish',
                    order: 'desc',
                },
                {
                    key: SortType.DATE_PUBLISH_ASC,
                    label: 'Дата публикации (возр.)',
                    field: 'datePublish',
                    order: 'asc',
                },
                {
                    key: SortType.DATE_START_DESC,
                    label: 'Дата начала работ (убыв.)',
                    field: 'dateStart',
                    order: 'desc',
                },
                {
                    key: SortType.DATE_START_ASC,
                    label: 'Дата начала работ (возр.)',
                    field: 'dateStart',
                    order: 'asc',
                },
                {
                    key: SortType.DATE_END_DESC,
                    label: 'Дата завершения работ (убыв.)',
                    field: 'dateEnd',
                    order: 'desc',
                },
                {
                    key: SortType.DATE_END_ASC,
                    label: 'Дата завершения работ (возр.)',
                    field: 'dateEnd',
                    order: 'asc',
                },
            ] as SortOption[],
        }
    },
    emits: ['apply-filter', 'reset-filter'],
    methods: {
        formatTextByNumber,
        onSortClick(sortOption: SortOption, close: () => void) {
            this.selectedSort = sortOption.key;
            close();

            const sortParam = [`${sortOption.field}=${sortOption.order}`];

            this.$emit('apply-filter', {
                type: 'cw',
                filters: [{
                    id: 'sort',
                    value: {
                        toServerParam: () => sortParam,
                    },
                }],
            });
        },
        onItemListFilterApply(filters: any) {
            // Преобразуем Filters объект в массив
            let filtersArray: any[] = [];

            if (Array.isArray(filters)) {
                filtersArray = filters;
            } else if (filters) {
                // Filters - это итерируемый объект
                try {
                    filtersArray = Array.from(filters, (f: any) => ({
                        id: f.id,
                        value: f.value
                    }));
                } catch (e) {
                    console.error('Error converting Filters to array:', e, filters);
                    // Fallback: пытаемся использовать for...of
                    filtersArray = [];
                    for (const f of filters) {
                        filtersArray.push({ id: f.id, value: f.value });
                    }
                }
            }

            this.$emit('apply-filter', {
                type: 'cw',
                filters: filtersArray,
            });
        },
        onItemListFilterReset() {
            this.$emit('reset-filter', {
                type: 'cw',
            });
        },
    },
    beforeMount() {
        const now = new Date();
        const options: Intl.DateTimeFormatOptions = {
            day: "numeric",
            month: "long",
        };
        this.dateUser = now.toLocaleDateString(undefined, options);
    },
});
